export function FileExplorerGalleryError() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <p className="text-sm text-ink-600">Failed to load files</p>
        <p className="mt-1 text-xs text-ink-500">
          Please try again later
        </p>
      </div>
    </div>
  );
}

